import { render, staticRenderFns } from "./radioButton.vue?vue&type=template&id=160e1488&scoped=true"
import script from "./radioButton.vue?vue&type=script&lang=js"
export * from "./radioButton.vue?vue&type=script&lang=js"
import style0 from "./radioButton.vue?vue&type=style&index=0&id=160e1488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e1488",
  null
  
)

export default component.exports